import styled from "styled-components"

const Prompt = styled.span`
  color: #212529;
  font-size: 14px;
`

export default Prompt